
import { defineComponent } from 'vue';

export default defineComponent({
    emits: ['close', 'import'],
    setup() {
        function download() {
            window.open('/download/template/Resident_RFCard,PIN_Template.xlsx');
        }

        return {
            download
        };
    }
});
